module.exports = __webpack_public_path__ + "img/victor_storchan_rounded_gray.e2193c38.jpg";